import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth"; // 🌟 인증 도구 추가

const firebaseConfig = {
  apiKey: "AIzaSyA4oK5JUuH-Hnz2xNPuiWYGNbN3vW8KpjA",
  authDomain: "chem-a0040.firebaseapp.com",
  databaseURL: "https://chem-a0040-default-rtdb.firebaseio.com",
  projectId: "chem-a0040",
  storageBucket: "chem-a0040.firebasestorage.app",
  messagingSenderId: "396051882129",
  appId: "1:396051882129:web:be87aca2c5e1715bd95f30"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const auth = getAuth(app); // 🌟 이제 로그인은 이 auth를 통해 합니다.